// extracted by mini-css-extract-plugin
module.exports = {"investment-tab":"InvestmentTab_investment-tab__cUCDg","investment-tab__btn":"InvestmentTab_investment-tab__btn__0v2TL"};